import PropTypes from 'prop-types'
import React from 'react'
import Link from 'gatsby-link'
import HeroVideo from '../components/hero-video'

const CreativeShop = ({
  desktopPosterSrc,
  mobilePosterSrc,
  desktopVideoSrc,
  mobileVideoSrc
}) => (
  <div className='creative-shop'>
    <div className='creative-shop__video'>
      <HeroVideo
        desktopPosterSrc={desktopPosterSrc}
        mobilePosterSrc={mobilePosterSrc}
        desktopVideoSrc={desktopVideoSrc}
        mobileVideoSrc={mobileVideoSrc}
      />
    </div>
    <div className='creative-shop__info'>
      <span className='creative-shop__eyebrow'>
        Creative shop
      </span>
      <h2 className='creative-shop__header'>
        Putting brands at<br />the center of culture
      </h2>
      <p className='creative-shop__description'>
        We put your brand at the center of culture, so you can become the center
        of attention. As your strategic and creative partner, we obsess over
        your audience to uncover human truths that lead us to big,
        transformative ideas and everyday engagement with consumers.
      </p>
      <div className='creative-shop__link'>
        <Link
          to='/creativeshop'
        >
          Explore
          <span className='fas fa-long-arrow-alt-right' />
        </Link>
      </div>
    </div>
  </div>
)

CreativeShop.propTypes = {
  desktopPosterSrc: PropTypes.string,
  mobilePosterSrc: PropTypes.string,
  desktopVideoSrc: PropTypes.string,
  mobileVideoSrc: PropTypes.string
}

export default CreativeShop



// WEBPACK FOOTER //
// ./src/components/creative-shop.js